<template>
    <input type="text"
           class="form-control"
           v-model="displayValue"
           @blur="isInputActive = false"
           @focus="isInputActive = true"
           @keydown="checkDecimal($event, this)"
           @change="changeEvent" />
</template>

<script>
export default {
    name: "NumberInput",
    props: ["value"],
    data: function() {
        return {
            isInputActive: false
        }
    },
    methods: {
        changeEvent(event) {
            this.$emit('change', event)
        }
    },
    computed: {
        displayValue: {
            get: function() {
                if (this.isInputActive) {
                    // Cursor is inside the input field. unformat display value for user
                    return this.value != null ? this.value.toString() : "0";
                } else {
                    let newValue = this.value != null ? this.value.toString() : "0";
                    // User is not modifying now. Format display value for user interface
                    //console.log("here", Math.abs(this.value).toLocaleString("en-US"))
                    if(newValue != null && newValue.includes('$')) {
                        return "$" + Math.abs(newValue.replace('$', '')).toLocaleString("en-US");
                    } else if(newValue != null && newValue.includes('%')) {
                        return Math.abs(newValue.replace('%', '')).toLocaleString("en-US") + "%";
                    }
                    return Math.abs(newValue).toLocaleString("en-US");
                }
            },
            set: function(modifiedValue) {
                // Recalculate value after ignoring "$" and "," in user input
                let newValue = parseFloat(modifiedValue.replace(/[^\d\.]/g, ""))
                // Ensure that it is not NaN
                if (isNaN(newValue)) {
                    newValue = 0
                }
                // Note: we cannot set this.value as it is a "prop". It needs to be passed to parent component
                // $emit the event so that parent component gets it
                this.$emit('input', newValue.toString())
            }
        }
    }
}
</script>

<style scoped>

</style>
